import Services from '../services';

export default {
  name: 'production',
  mixins: [Services],
  data() {
    return {
      types: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'Production',
          value: 'production'
        },
        {
          name: 'Disassembly',
          value: 'disassembly'
        },
      ],
      type: {
        name: 'All',
        value: ''
      },
      production_edit_index: -1,
      productions: [],
      production: {
        items: []
      },
      productions_page: 1,
      productions_total: 0,
      data_loading: false
    }
  },
  methods: {
    async update_productions() {
      this.data_loading = true
      var productions = this.$communicator.then(this, await this.$communicator('productions', {
        arguments: [10, this.productions_page],
        params: {
          service: this.store?._id,
          type: this.type.value,
          search: this.search
        }
      }))
      if (productions) {
        for (let i = 0;i < productions.data.length;i++) {
          productions.data[i].created_time = this.date_ddmmyy(productions.data[i].created_time)
        }
        this.productions = productions.data
        this.productions_total = productions.page
      }
      this.data_loading = false
    }
  },
  mounted() {
    this.types = [
      {
        name: this.$t('all'),
        value: ''
      },
      {
        name: this.$t('production'),
        value: 'production'
      },
      {
        name: this.$t('disassembly'),
        value: 'disassembly'
      },
    ]
    this.type = {
      name: this.$t('all'),
      value: ''
    }
    this.update_productions()
  }
}